import {
  Select,
  SelectButton,
  SelectListBox,
  SelectListItem,
  SelectPopover,
} from "@/components/select";

import type { BrandRequestFilterId } from "./config/filterConfig";

import { BRAND_REQUEST_FILTERS } from "./config/filterConfig";

interface BrandRequestsFilterDropdownProps {
  readonly onFilterChange: (filter: BrandRequestFilterId) => void;
  readonly selectedFilter: BrandRequestFilterId;
}

export function BrandRequestsFilterDropdown({
  onFilterChange,
  selectedFilter,
}: BrandRequestsFilterDropdownProps) {
  return (
    <Select
      aria-label="Filter requests"
      className="w-full sm:w-fit min-w-[170px] sm:shrink-0"
      onSelectionChange={(key) => onFilterChange(key as BrandRequestFilterId)}
      selectedKey={selectedFilter}
    >
      <SelectButton className="font-semibold" />
      <SelectPopover>
        <SelectListBox>
          {BRAND_REQUEST_FILTERS.map((option) => (
            <SelectListItem
              id={option.id}
              key={option.id}
              textValue={option.label}
            >
              {option.label}
            </SelectListItem>
          ))}
        </SelectListBox>
      </SelectPopover>
    </Select>
  );
}
